import { Box, Grid, Button } from "@mui/material";
import RenderFileDetail from "./renderFileDetail";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import React from "react";
import { IFile } from "../interface/iFile";
import { ParticipantFilesContext } from "../context/participantFilesContext";

const UploadTile = ({
  file,
  deletable,
}: {
  file: IFile;
  deletable?: boolean;
}): React.JSX.Element => {
  const {
    deleteFile,
    downloadFile,
  }: {
    deleteFile: (
      fileId: string,
      setConfirmDelete: React.Dispatch<React.SetStateAction<boolean>>
    ) => void;
    downloadFile: (file: IFile) => void;
  } = React.useContext(ParticipantFilesContext);

  const [confirmDelete, setConfirmDelete] = React.useState(false);

  return (
    <Box
      sx={{
        backgroundColor: "#eeeeee",
        px: 2,
        py: 1,
        borderRadius: 2,
        mt: 1,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <RenderFileDetail label={"Dateiname"} shownDetail={file.name} />
        </Grid>

        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: {
              xs: "center",
              md: "flex-end",
            },
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Button
            size="small"
            onClick={() => downloadFile(file)}
            startIcon={<FileDownloadOutlinedIcon />}
            variant="contained"
            color="secondary"
          >
            Download
          </Button>

          <Button
            onClick={
              confirmDelete
                ? () => deleteFile(file.id, setConfirmDelete)
                : () => setConfirmDelete(true)
            }
            disabled={!deletable}
            size="small"
            startIcon={<DeleteOutlinedIcon />}
            variant="outlined"
            color="secondary"
          >
            {confirmDelete ? "Sicher?" : "Löschen"}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UploadTile;
